import { ConnectorType } from '@reown/appkit-core';
import { ContractAbi } from 'web3';
import { ContractAddress, GeneralSettings, MainPoolInfo } from '..';
import { ethers } from 'ethers';

export class MoonStaking {
    provider: ethers.providers.Web3Provider;
    contractAddress: ContractAddress;
    walletAddress: ContractAddress;
    abi: ContractAbi;
    signer: ethers.providers.JsonRpcSigner;
    contract: ethers.Contract;

    constructor(contractAddress: ContractAddress, abi: ContractAbi, provider: ConnectorType, walletAddress: ContractAddress) {
        this.abi = abi;
        this.contractAddress = contractAddress;
        this.walletAddress = walletAddress;
        //@ts-ignore
        this.provider = new ethers.providers.Web3Provider(provider);
        this.signer = this.provider.getSigner(this.walletAddress);
        this.contract = new ethers.Contract(this.contractAddress, this.abi, this.signer);
    }

    async getMainPoolInfo(): Promise<MainPoolInfo | null> {
        try {
            return await this.contract.mainPoolInfo();
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async getGeneralSettings(): Promise<GeneralSettings | undefined> {
        try {
            const gs = (await this.contract.generalSettings()) as GeneralSettings;

            return gs;
        } catch (error) {
            console.log('Error getting user balance', error);
            return undefined;
        }
    }
}
